module.exports = __webpack_public_path__ + "static/1-010fbf4a9ea10ab2db29cecfe133de3a.png";